/*
 * 卓を立てる操作はタブレット / PC だけに出す。
 *
 * 中央ディスプレイは卓の中央に置いて全員が離れた位置から読む画面で、スマホでは務まらない
 * （要件11.9）。スマホで開いた人がすることは参加だけなので、選択肢を1つに絞る。
 *
 * 幅だけで判定すると横向きのスマホが PC 扱いになる（iPhone 13 横向きは 844x390）。
 * 高さも見て、縦にも余裕がある画面に限る。
 *
 * JS のメディアクエリ（useMediaQuery）ではなく CSS で消す。初回レンダリングで判定できない
 * 実装だと、スマホでも一瞬「卓を立てる」が見えてから消える。
 */

.createTable {
  display: none;
}

@media (min-width: 48em) and (min-height: 36em) {
  .createTable {
    display: flex;
  }
}
